module.exports = __webpack_public_path__ + "img/img35.e76213b1.png";